import React from 'react';

import '../icon-component.scss';

const TickSuccessComponent = () => (
  <svg className="icon-component" viewBox="0 0 23 15">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1571.000000, -2365.000000)">
        <g transform="translate(1559.000000, 2347.000000)">
          <path d="M21.1710322,32.6495692 L13.1710322,24.6135692 C12.786642,24.2275692 12.7788371,23.5935692 13.1573737,23.1995692 C13.5378615,22.8075692 14.1544468,22.7975692 14.5368859,23.1855692 L21.1710322,29.8495692 L32.6832273,18.2855692 C33.0676176,17.8975692 33.6842029,17.9075692 34.0627395,18.2995692 C34.4412761,18.6935692 34.4334712,19.3275692 34.049081,19.7135692 L21.1710322,32.6495692 Z" />
        </g>
      </g>
    </g>
  </svg>
);

TickSuccessComponent.displayName = 'TickSuccessIcon';

export default TickSuccessComponent;
